export default function formatDate(string) {
  if (!string) return '';
  let result = string.split(' ');
  return result[0] + (result[1] ? ' <strong>' + result[1]  + '</strong>' : '');
}